// src/components/PCP/PCPDashboard.tsx
import React, { useEffect } from 'react';
import { Outlet, useOutletContext, useLocation, useOutlet, matchPath } from 'react-router-dom';

// Importe as interfaces necessárias do seu ProductionFashionContent.tsx
// Ajuste o caminho real!
// Importe seus componentes de visualização da tabela e do quadro
import TablePCP from '../ProductionTable/index'; // Ajuste o caminho real
import BoardPCP from '../ProductionGrid/index'; // Ajuste o caminho real
import { ProductionFashionOutletType } from '..';

const PCPDashboard: React.FC = () => {
    // Acessa os estados do ProductionFashionContent via useOutletContext
    // ProductionFashionContent passa: tabIndex, setTabIndex, pcpView, setPCPView
    const { pcpView } = useOutletContext<ProductionFashionOutletType>();
    const location = useLocation();

     // A rota base do PCPDashboard é 'pcp'.
    // Precisamos verificar se a URL atual corresponde à rota 'create'.
    const isCreateRouteActive = matchPath(
        { path: 'pcp/create', end: true }, // 'path' relativo ao pai 'pcp', 'end: true' para correspondência exata
        location.pathname // O pathname completo
    );

    console.log("PCPDashboard: Renderizando. Pathname:", location.pathname);
    console.log("PCPDashboard: pcpView:", pcpView);
    console.log("PCPDashboard: outletContent (se houver filho):", isCreateRouteActive);

    return (
        <>
            {/* O Outlet renderiza o componente da rota filha correspondente (ex: AddFashionOP) */}
            {/* Se houver um filho, ele será renderizado aqui. */}
            {isCreateRouteActive ? (
                <Outlet />
            ) : (
                // SENÃO (estamos na rota /pcp, não /pcp/create), renderize o switch Tabela/Quadro
                <>
                    <h2>--- Estou no PCPDashboard (Switching Views) ---</h2> {/* Texto para depuração */}
                    {pcpView === 'table' ? (
                        <TablePCP />
                    ) : (
                        <BoardPCP />
                    )}
                </>
            )}
        </>
    );
};

export default PCPDashboard;